import { IEntityBase } from './entityBase';

export enum ProductInvoiceType {
  'NF' = 'Nota Fiscal',
  'ND' = 'Nota Débito',
}

export interface IProductBase extends IEntityBase {
  name: string;
  isActive: boolean;
  ventureId: string;
  costCenter: string;
  productCode: string;
  productType: string;
  productNature: string;
  description?: string;
  invoiceType: 'NF' | 'ND';
}
